import { action } from 'satcheljs';
import { CommandBarAction } from 'owa-mail-commandbar-actions/lib/CommandBarAction';

export default action(
    'onCommandBarEditorSaved',
    (newSurfaceActions: CommandBarAction[], newOverflowActions: CommandBarAction[]) => ({
        newSurfaceActions,
        newOverflowActions,
    })
);
